import React from "react";
import { Box, makeStyles } from "@material-ui/core";
import { PrimaryButton } from "./";
import { Theme } from "../../.themes";
import clsx from "clsx";

// set desktop size;
const useStyles = makeStyles((theme: Theme) => ({
  container: {
    margin: `${theme.spacing(2)}px 0 ${theme.spacing(5)}px`,
    [theme.breakpoints.up("sm")]: {
      maxWidth: theme.containerMaxWidth,
    },
  },
  button: {
    fontSize: "1.25rem",
    lineHeight: "1.5rem",
    minHeight: 56,
    ...theme.button,
  },
}));

const NavToButton: React.FC<ButtonProps> = (props: ButtonProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <PrimaryButton
        className={clsx(classes.button, props.className)}
        id={props.id}
        endIcon={(props.icon ?? true) && ""}
        fullWidth={true}
        onClick={() => props.onClick()}
      >
        {props.children}
      </PrimaryButton>
    </Box>
  );
};

type ButtonProps = {
  onClick: Function;
  children: React.ReactNode;
  icon?: boolean;
  id?: string;
  className?: string;
};

export default NavToButton;
